@if (equipmentType && (active || defaultVisible || defaultHidden)) {
  <div class="equipment-tier-picker-container">
    <ng-template #cosmeticOptionIcon let-options="options" let-hidden="hidden">
      @if (hidden) {
        <span class="icon icon-eye-blocked"></span>
      } @else if (options.highlight && options.minimapIconShape) {
        <app-minimap-icon [cosmeticOptions]="options"></app-minimap-icon>
      } @else if (options.highlight && options.beam) {
        <app-highlight-beam-icon [highlightColor]="options.highlightColor!"></app-highlight-beam-icon>
      } @else {
        <span class="icon icon-eye"></span>
      }
    </ng-template>

    <div class="style-preview" [class.disabled]="disabled" [class.standalone]="standalone" (click)="openStylePickerDialog()">
      <app-tooltip-wrapper [noPadding]="true" [border]="'around'" [right]="!alignLeft" [rowStyle]="true">
        @if ((active && hidden) || (!active && defaultHidden)) {
          <span class="icon icon-eye-blocked"></span>
        } @else if (!active && defaultVisible) {
          <span class="icon icon-eye"></span>
        } @else if (cosmeticOptions) {
          @if (cosmeticOptions.highlight && cosmeticOptions.minimapIconShape) {
            <app-minimap-icon [cosmeticOptions]="cosmeticOptions"></app-minimap-icon>
          } @else if (cosmeticOptions && cosmeticOptions.highlight && cosmeticOptions.beam) {
            <app-highlight-beam-icon [highlightColor]="cosmeticOptions.highlightColor!"></app-highlight-beam-icon>
          } @else {
            <span class="icon icon-eye"></span>
          }
        }
        @if (!dialogOpen) {
          <ng-template #tooltip>
            <div class="label-background" [style.background-image]="labelBackgroundImage()">
              <div class="item-label">
                <div app-label-viewer [displayOptions]="{ active: active, displayType: DisplayType.Custom, hidden: hidden, cosmeticOptions: cosmeticOptions }"
                  [forceHidden]="!active && defaultHidden"
                  [rareName]="rareName"
                  [exampleName]="exampleName" [stackSize]="stackSize" [rarity]="rarity" [disableBackground]="true" [sockets]="sockets" [isPoe1Gem]="isPoe1Gem" [isCurrency]="isCurrency" [isWaystone]="isWaystone"
                  [influence]="influence" [fractured]="fractured" [synthesised]="synthesised" [veiled]="veiled" [memoryStrands]="memoryStrands"></div>
              </div>
            </div>
          </ng-template>
        }
      </app-tooltip-wrapper>
    </div>

    @if (dialogOpen) {
      <div class="equipment-tier-picker-dialog" [class.right-aligned]="!alignLeft" (click)="$event.stopPropagation()">
        <div class="tier-picker-main-row">
          @if (alignLeft) {
            <div class="tier-option close-button" (click)="closeStylePickerDialog()" title="Close">
              ✕
            </div>
          }
          <div class="tier-option custom-option" [class.current]="hasCustomRuleStyle" (click)="openCustomStylePicker()" title="Custom Style">
            @if (hasCustomRuleStyle) {
              <ng-container [ngTemplateOutlet]="cosmeticOptionIcon" [ngTemplateOutletContext]="{ options: customCosmeticOptions, hidden: false }" />
            } @else {
              <span class="icon icon-pencil"></span>
            }
          </div>
          @for (tierOption of tierOptions; track tierOption.tier) {
            <div class="tier-option" [class.current]="!hasCustomRuleStyle && tierOption.tier === tier" (click)="selectTier(tierOption.tier)">
              <ng-container [ngTemplateOutlet]="cosmeticOptionIcon" [ngTemplateOutletContext]="{ options: tierOption.cosmeticOptions, hidden: tierOption.hidden }" />
            </div>
          }
          @if (!alignLeft) {
            <div class="tier-option close-button" (click)="closeStylePickerDialog()" title="Close">
              ✕
            </div>
          }
        </div>
        @if (showQuickApplyLibrary()) {
          <div class="library-quick-row">
            <div class="tier-option" (click)="openQuickApplyLibraryPicker()" title="Style library">
              <span class="icon icon-drawer"></span>
            </div>
            @for (item of libraryQuickOptions; track item.entry.id) {
              <div class="tier-option" [class.current]="item.isCurrent" [title]="item.entry.name" (click)="applyLibraryEntry(item.options)">
                <ng-container [ngTemplateOutlet]="cosmeticOptionIcon" [ngTemplateOutletContext]="{ options: item.options, hidden: false }" />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (stylePickerDialogOpen) {
    <app-style-picker-dialog
      (close)="closeCustomStylePicker()"
      (styleUpdated)="onCustomStyleUpdated()"
      (customRuleStyleCleared)="onCustomRuleStyleCleared()"
      [ruleId]="equipment!.ruleId"
      [displayable]="dummyDisplayable"
      [exampleName]="exampleName"
      [rarity]="rarity"
      [sockets]="sockets"
      [influence]="influence"
      [fractured]="fractured"
      [synthesised]="synthesised"
      [veiled]="veiled"
      [isCurrency]="isCurrency"
      [isPoe1Gem]="isPoe1Gem"
      [isWaystone]="isWaystone"
      [allowDisactivate]="false"
      [allowHide]="false"></app-style-picker-dialog>
  }

  @if (libraryPickerOpen) {
    <app-style-library-picker-dialog
      [rarity]="rarity"
      [sockets]="sockets"
      [influence]="influence"
      [fractured]="fractured"
      [veiled]="veiled"
      [synthesised]="synthesised"
      [isCurrency]="isCurrency"
      [isWaystone]="isWaystone"
      [isPoe1Gem]="isPoe1Gem"
      (selected)="onLibraryStyleSelected($event)"
      (close)="closeLibraryPicker()">
    </app-style-library-picker-dialog>
  }
}
